module.exports = __webpack_public_path__ + "img/vinleit-nav-logo.bd83d246.jpg";